import type { TargetDefinition } from '@/types/webflash';

/**
 * STM32F407VG — Cortex-M4, 1 MB flash, 192 KB SRAM, hardware CRC
 */
export const STM32F4: TargetDefinition = {
  name: 'STM32F407VG',
  partNumber: 'STM32F407VG',
  idcodes: [0x2BA01477], // Cortex-M4 SWD IDCODE
  cpuType: 'CM4',
  flashBase: 0x08000000,
  flashSize: 1024 * 1024,  // 1 MB
  ramBase: 0x20000000,
  ramSize: 128 * 1024,     // 128 KB main SRAM (+ 64 KB CCM)
  hasHardwareCRC: true,
  crcPeripheralAddr: 0x40023000,
  sectors: [
    // Sector 0–3: 16 KB each
    { address: 0x08000000, size: 16 * 1024 },
    { address: 0x08004000, size: 16 * 1024 },
    { address: 0x08008000, size: 16 * 1024 },
    { address: 0x0800C000, size: 16 * 1024 },
    // Sector 4: 64 KB
    { address: 0x08010000, size: 64 * 1024 },
    // Sector 5–11: 128 KB each
    { address: 0x08020000, size: 128 * 1024 },
    { address: 0x08040000, size: 128 * 1024 },
    { address: 0x08060000, size: 128 * 1024 },
    { address: 0x08080000, size: 128 * 1024 },
    { address: 0x080A0000, size: 128 * 1024 },
    { address: 0x080C0000, size: 128 * 1024 },
    { address: 0x080E0000, size: 128 * 1024 },
  ],
};
